import React, {Component} from 'react'
import {FormattedMessage} from 'react-intl'

class CommitmentDurationLabel extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            value: this.props.value || '',
            billingMethod: this.props.billingMethod || '',
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value || '',
            billingMethod: nextProps.billingMethod || '',
        })
    }

    render() {
        if (!this.state.billingMethod || this.state.billingMethod !== 'recurring') {
            return <span />
        }
        switch (this.state.billingMethod) {
            case "monthly":
                return <FormattedMessage
                    id="common.billing_method.label.month_label_long"
                    defaultMessage="{measure, plural, one {for # month} other {for # months}}"
                    values={{
                        measure: this.state.value
                    }}
                />
            case "yearly":
                return <FormattedMessage
                    id="common.billing_method.label.year_label_long"
                    defaultMessage="{measure, plural, one {for # year} other {for # years}}"
                    values={{
                        measure: this.state.value
                    }}
                />
        }
    }
}

export default CommitmentDurationLabel





// WEBPACK FOOTER //
// ./src/common/pricing/commitmentdurationlabel.component.jsx